<template>
  <div>
    <div class="banner">
      <!--      <img src="../../static/images/contact/banner.png" alt="banner">-->
      <!--      <img src="https://s3.bmp.ovh/imgs/2022/04/01/0b340bc1547e6f6f.png" alt="banner">-->
      <img :src="img_src.banner" alt="banner">
    </div>

    <div class="content contact-wrap">
      <div class="title-row">
        <div class="title">联 系 我 们</div>
        <div class="sub-title">Contact Us</div>
        <p class="line"></p>
      </div>

      <baidu-map class="map" :center="markerPoint" :zoom="15" :scroll-wheel-zoom="true">
        <bm-marker :position="markerPoint" :dragging="true" @click="infoWindowOpen">
          <bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen">
            江西玉鸿图大数据发展有限公司
            <p style="margin-top: 10px;font-size: 13px;">江西省赣州市章贡区武当山路1号国家高层次人才科创园12栋3层</p>
            <p v-if="false" style="margin-top: 10px;font-size: 14px;">客服热线：400-9158-120</p>
          </bm-info-window>
          <!-- 缩放 -->
          <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
          <!-- 比例尺 -->
          <bm-scale></bm-scale>
        </bm-marker>
      </baidu-map>

      <ul class="contact-types">
        <li>
          <div class="img-box">
            <!--            <img src="/static/images/contact/icon1.png" alt="icon1">-->
            <img :src="img_src.icon1" alt="icon1">
          </div>
          <div>联系电话</div>
          <p>欢迎致电：189011111100</p>
        </li>
        <li>
          <div class="img-box">
            <!--            <img src="/static/images/contact/icon2.png" alt="icon2">-->
            <img :src="img_src.icon2" alt="icon2">
          </div>
          <div>联系地址</div>
          <p>公司地址：江西省赣州市章贡区武当山路1号国家高层次人才科创园12栋3层</p>
          <p>总部地址：南京市雨花台区软件大道109号910室</p>
        </li>
        <li>
          <div class="img-box">
            <!--            <img src="/static/images/contact/icon3.png" alt="icon3">-->
            <img :src="img_src.icon3" alt="icon3">
          </div>
          <div>邮件传送</div>
          <p>189011111100@189.cn</p>
        </li>
      </ul>
    </div>

    <div class="content contact-form">
      <div class="title-row">
        <div class="title">留 言</div>
        <div class="sub-title">Message </div>
        <p class="line"></p>
      </div>

      <div class="form-wrap">
        <div class="form-title">发表您的留言：</div>
        <ValidationObserver ref="ruleForm" tag="div" class="form-boserver" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(onSubmit)">
            <div class="form-flex">
              <ValidationProvider tag="div" class="form-item" rules="required" name="name" v-slot="{ errors }">
                <label>姓名：</label>
                <input v-model="name" type="text" autocomplete="off">
                <p class="ml-3">{{ errors[0] }}</p>
              </ValidationProvider>
              <ValidationProvider class="form-item" name="email" tag="div" rules="required|email" v-slot="{ errors }">
                <label>邮箱：</label>
                <input v-model="email" type="text" autocomplete="off" placeholder="如： 122345@qq.com" />
                <p class="ml-3">{{ errors[0] }}</p>
              </ValidationProvider>
              <ValidationProvider class="form-item" name="phone" tag="div" rules="required|numeric" v-slot="{ errors }">
                <label>电话：</label>
                <input v-model="phone" type="text" autocomplete="off" />
                <p class="ml-3">{{ errors[0] }}</p>
              </ValidationProvider>
            </div>
            <ValidationProvider class="form-textarea" name="remarks" tag="div" rules="required" v-slot="{ errors }">
              <label>内容：</label>
              <!-- <input v-model="remarks" type="text" autocomplete="off" /> -->
              <textarea v-model="remarks" autocomplete="off"></textarea>
              <p class="ml-3">{{ errors[0] }}</p>
            </ValidationProvider>
            <div class="btn-row">
              <button @click="onSubmit">提 交 留 言</button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate'
import { required, email, min, length, confirmed, numeric } from 'vee-validate/dist/rules'
import zh from 'vee-validate/dist/locale/zh_CN.json'
extend('email', email)
extend('numeric', numeric)

extend('min', min)
extend('required', required)

extend('length', length)

extend('confirmed', confirmed)

extend('password', {
  validate(value, { min, max }) {
    return value.length >= min && value.length <= max
  },
  params: ['min', 'max']
})
localize({
  'zh-CN': {
    names: {
      email: '邮箱',
      phone: '电话',
      name: '姓名',
      remarks: '内容'
    },
    messages: {
      ...zh.messages,
      required: '请输入{_field_}',
      email: '请输入正确的邮箱格式'
    }
  }
})

localize('zh-CN')
export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      img_src: {
        banner: 'https://s1.ax1x.com/2022/04/02/qoKHOS.png',
        icon1: 'https://s1.ax1x.com/2022/04/06/qXTaoF.png',
        icon2: 'https://s1.ax1x.com/2022/04/06/qXTUdU.png',
        icon3: 'https://s1.ax1x.com/2022/04/06/qXTNZT.png',
      },
      show: true,
      // 坐标
      markerPoint: {
        // lng: 118.770074,
        // lat: 31.985389,
        lng: 114.996536,
        lat: 25.840366,
      },
      name: '',
      email: '',
      phone: '',
      remarks: ''
    }
  },
  methods: {
    infoWindowClose() {
      this.show = false
    },
    infoWindowOpen() {
      this.show = true
    },
    onSubmit() {
      console.log()
      this.$refs.ruleForm.validate().then(bool => {
        if (bool) {
          this.name = this.email = this.remarks = ''
          /* this.$nextTick(() => {
            this.$refs.ruleForm.reset()
          }) */

          this.$router.push({ path: '/Home' })
        }
      })
      // alert('Form submitted!')
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  min-width: 1200px;
  margin-bottom: 102px;

  img {
    width: 100%;
  }
}

.title-row {
  margin-bottom: 88px;
  text-align: center;

  .title {
    font-size: 48px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #00A0E9;
  }

  .sub-title {
    margin-top: 5px;
    margin-bottom: 10px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #808080;
    letter-spacing: 2px;
  }

  .line {
    width: 42px;
    height: 7px;
    margin: 0 auto;
    background: #00A0E9;
  }
}

.contact-wrap {
  margin-bottom: 198px;

  .map {
    height: 524px;
  }

  .contact-types {
    display: flex;
    justify-content: space-between;
    text-align: center;

    .img-box {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      height: 129px;
    }

    div {
      font-size: 48px;
      font-weight: bold;
      color: #00A0E9;
      margin-top: 74px;
      margin-bottom: 46px;
    }

    p {
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
    }
  }
}

.form-wrap {
  margin-bottom: 100px;

  .form-title {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 20px;
    letter-spacing: 2px;
  }

  .form-boserver {
    padding-left: 50px;
  }

  .form-flex {
    display: flex;
    justify-content: space-between;
  }

  .form-item {
    min-height: 56px;
  }

  .form-textarea {
    margin: 47px 0;
    min-height: 152px;

    label {
      vertical-align: top;
    }
  }

  label {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
  }

  input {
    width: 223px;
    height: 35px;
    border: 1px solid #A0A0A0;
    text-indent: 10px;

    &:focus {
      border: 1px solid #2DA7E0;
    }
  }

  textarea {
    width: 1097px;
    height: 127px;
    border: 1px solid #A0A0A0;
    text-indent: 10px;
  }

  .ml-3 {
    margin-left: 55px;
    color: red;
  }

  .btn-row {
    margin-left: 55px;

    button {
      width: 289px;
      height: 66px;
      border: 1px solid rgb(1, 176, 241);
      background: #01B0F1;
      outline: none;
      font-size: 18px;
      font-weight: bold;
      color: #FFFFFF;

      &:active {
        background: rgb(28, 154, 196);
      }

      &:hover {
        background-image: linear-gradient(rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.15));
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Contact.vue